import AxiosInstance from "./api";

export const HandoverRecordRufAssetsService = {
  getPaginate: async (payload) => {
    const query = new URLSearchParams(payload);
    return await AxiosInstance.get("/private/handover-record-ruf-assets", { params: query });
  },
  getById: async (id) => {
    return await AxiosInstance.get(`/private/handover-record-ruf-assets/${id}`);
  },
  create: async (payload) => {
    return await AxiosInstance.post("/private/handover-record-ruf-assets", payload);
  },
  update: async (id, payload) => {
    return await AxiosInstance.patch(`/private/handover-record-ruf-assets/${id}`, payload);
  },
  delete: async (id) => {
    return await AxiosInstance.delete(`/private/handover-record-ruf-assets/${id}`);
  },
};
